(function (ws) {
    'use strict';
    ws.views.reviewsubmitTable = ws.views.staticTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'rma_activity',
        GTM_EVENT_ACTION: 'request rma submit',

        events: {
            'click  #review-submit': 'reviewAndSubmit'
        },

        /**
         * initialize override
         */
        initialize: function () {
            this.$table = this.$('#review-submitTable');
            this.responsivePriority = [
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 2}
            ];

            ws.views.staticTable.prototype.initialize.call(this);
        },

        /**
         * log RMA GTM event and submit form
         */
        reviewAndSubmit: function(e) {
            var $form = $(e.currentTarget).parents('#rmaReview');
            e.preventDefault();
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            $form.submit();
        }
    });
}(westcon));
